import { render, staticRenderFns } from "./DesafioSubmissions.vue?vue&type=template&id=403a4bfa&"
import script from "./DesafioSubmissions.vue?vue&type=script&lang=js&"
export * from "./DesafioSubmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports